module.exports = __webpack_public_path__ + "img/wb_logo.d9c37684.png";